import React from 'react';
import { connect, useSelector } from 'react-redux';
import { hasFeatures } from './features';
import { RootState } from '../../store';
import { useAppSelector } from '../../hooks/redux-hooks';

export interface IFeatureFlaggedProps {
    features: string[];
    children: JSX.Element;
}

//** Exported for testing purposes */
export const FeatureFlagged = ({
    features,
    children,
}: IFeatureFlaggedProps) => {
    const session = useAppSelector((state: RootState) => state.session!.data!);
    return <>{hasFeatures(session, features) && children}</>;
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session!.data!,
    };
};

const featureFlaggedContainer = connect(mapStateToProps, null)(FeatureFlagged);

export default featureFlaggedContainer;
